// import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
// import { signImSchema } from "../../../schema";
import AdminListService from "../../../services/admin-list.service";
import "./login.css";

// import { useDispatch } from "react-redux";
// import { bindActionCreators } from "redux";
// import { actionCreaters } from "../../../Redux/index";
import { Helmet } from "react-helmet";
import secureLocalStorage from "react-secure-storage";

export default function Login() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // const dispatch = useDispatch();
  // const userActions = bindActionCreators(actionCreaters, dispatch);

  const { type } = useParams();

  useEffect(() => {
    if (
      type !== "osr" &&
      type !== "pavlina" &&
      type !== "accountant" &&
      type !== "customer" &&
      type !== "login"
    ) {
      navigate("/admin/login");
    }

    secureLocalStorage.setItem("panel", "admin");
    // eslint-disable-next-line
  }, [type]);

  // const loginCheck = async (values) => {
  //   setLoading(true);
  //   try {
  //     if (type === "customer") {
  //       const response = await AdminListService.loginCustomer(values);

  //       if (response.status === 200) {
  //         await userActions.logIn(
  //           {
  //             customerAccessToken: response.data.data.access_token,
  //             customer_id: response.data.data.AdminId,
  //             customerSiteId: response.data.data.SiteId,
  //           },
  //           "customerLogin",
  //         );
  //         navigate("/3in1Step", { replace: true });
  //         setLoading(false);
  //       }
  //     } else if (type === "osr") {
  //       const response = await AdminListService.loginOsr(values);

  //       if (response.status === 200) {
  //         await userActions.logIn(
  //           {
  //             osrAccessToken: response.data.data.access_token,
  //             osr_id: response.data.data.OsrId,
  //           },
  //           "osrLogin",
  //         );

  //         navigate("/osr_dashboard", { replace: true });
  //         setLoading(false);
  //       }
  //     } else if (type === "pavlina") {
  //       const response = await AdminListService.loginPavlina(values);

  //       if (response.status === 200) {
  //         await userActions.logIn(
  //           {
  //             pavlinaAccessToken: response.data.data.access_token,
  //             pavlina_id: response.data.data.pavlinaId,
  //           },
  //           "pavlinaLogin",
  //         );
  //         navigate("/searchcerti_pav", { replace: true });

  //         setLoading(false);
  //       }
  //     } else if (type === "accountant") {
  //       const response = await AdminListService.loginAccountant(values);

  //       if (response.status === 200) {
  //         await userActions.logIn(
  //           {
  //             accountantAccessToken: response.data.data.access_token,
  //             accountant_id: response.data.data.AccId,
  //           },
  //           "accountantLogin",
  //         );
  //         navigate("/account_dashboard", { replace: true });
  //         setLoading(false);
  //       }
  //     } else if (type === "login") {
  //       const response = await AdminListService.loginAdmin(values);
  //       if (response.status === 200) {
  //         await userActions.logIn(
  //           {
  //             adminAccessToken: response.data.data.access_token,
  //             admin_id: response.data.data.AdminId,
  //           },
  //           "adminLogin",
  //         );
  //         navigate("/admin_dashboard", { replace: true });
  //         setLoading(false);
  //       }
  //     }
  //   } catch (err) {
  //     setLoading(false);

  //     if (err?.response?.status === 401) {
  //       toast.error("Username or Password is invalid!", {
  //         position: "top-right",
  //         autoClose: 3000,
  //         hideProgressBar: true,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "colored",
  //       });
  //     } else if (
  //       err?.response?.data?.message &&
  //       typeof err?.response?.data?.message === "string"
  //     ) {
  //       toast.error(err?.response?.data?.message, {
  //         position: "top-right",
  //         autoClose: 3000,
  //         hideProgressBar: true,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "colored",
  //       });
  //     } else {
  //       toast.error("Something went wrong, try again", {
  //         position: "top-right",
  //         autoClose: 3000,
  //         hideProgressBar: true,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: "colored",
  //       });
  //     }
  //   }
  // };

  // const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
  //   useFormik({
  //     initialValues: {
  //       username: "",
  //       password: "",
  //     },
  //     validationSchema: signImSchema,
  //     onSubmit: (values, action) => {
  //       loginCheck(values);
  //     },
  //   });
  const loginExternal = async (loginWith) => {
    try {
      setLoading(true);
      const response = await AdminListService.getLoginAzureLink(
        loginWith,
        type,
      );

      setTimeout(() => {
        setLoading(false);
        window.location.href = response?.data?.url;
      }, 200);
    } catch (err) {
      if (err?.message === "Network Error") {
        loginExternal(loginWith);
      } else {
        setLoading(false);
        if (
          err?.response?.data?.message &&
          typeof err?.response?.data?.message === "string"
        ) {
          toast.error(err?.response?.data?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error("Something went wrong, try again", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      }
    }
  };
  return (
    <div className="login-main">
      <Helmet>
        {type === "customer" ? (
          <title> {process.env.REACT_APP_SITE_NAME} Customers Login</title>
        ) : type === "osr" ? (
          <title> {process.env.REACT_APP_SITE_NAME} OSR Login</title>
        ) : type === "accountant" ? (
          <title> {process.env.REACT_APP_SITE_NAME} Accountant Login</title>
        ) : type === "pavlina" ? (
          <title> {process.env.REACT_APP_SITE_NAME} Pavlina Login</title>
        ) : type === "login" ? (
          <title>Admin Panel For CoreAdmin</title>
        ) : (
          <title>Admin Panel For CoreAdmin</title>
        )}
      </Helmet>

      <div className="container">
        <div className="box-outer">
          <div className="login-box">
            <div className="mws-login-lock">
              <i className="bi bi-lock-fill"></i>
            </div>
            <div className="col-lg-12 login-key">
              <img
                src="https://res.cloudinary.com/sparkcloudsforewards/image/upload/v1718344862/logo_l667oi.png"
                alt=""
              />
            </div>

            <div className="col-lg-12 login-form">
              <div className="col-lg-12 login-form">
                <button
                  type="button"
                  className="azure-login-button"
                  onClick={() => {
                    loginExternal("azure");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="800px"
                    height="800px"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path fill="#F35325" d="M1 1h6.5v6.5H1V1z" />
                    <path fill="#81BC06" d="M8.5 1H15v6.5H8.5V1z" />
                    <path fill="#05A6F0" d="M1 8.5h6.5V15H1V8.5z" />
                    <path fill="#FFBA08" d="M8.5 8.5H15V15H8.5V8.5z" />
                  </svg>
                  Login With Microsoft
                </button>
                <button
                  type="button"
                  className="azure-login-button google-login mt-2"
                  onClick={() => {
                    loginExternal("google");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="800px"
                    height="800px"
                    viewBox="-0.5 0 48 48"
                  >
                    <defs />
                    <g
                      id="Icons"
                      stroke="none"
                      strokeWidth={1}
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        id="Color-"
                        transform="translate(-401.000000, -860.000000)"
                      >
                        <g
                          id="Google"
                          transform="translate(401.000000, 860.000000)"
                        >
                          <path
                            d="M9.82727273,24 C9.82727273,22.4757333 10.0804318,21.0144 10.5322727,19.6437333 L2.62345455,13.6042667 C1.08206818,16.7338667 0.213636364,20.2602667 0.213636364,24 C0.213636364,27.7365333 1.081,31.2608 2.62025,34.3882667 L10.5247955,28.3370667 C10.0772273,26.9728 9.82727273,25.5168 9.82727273,24"
                            id="Fill-1"
                            fill="#FBBC05"
                          />
                          <path
                            d="M23.7136364,10.1333333 C27.025,10.1333333 30.0159091,11.3066667 32.3659091,13.2266667 L39.2022727,6.4 C35.0363636,2.77333333 29.6954545,0.533333333 23.7136364,0.533333333 C14.4268636,0.533333333 6.44540909,5.84426667 2.62345455,13.6042667 L10.5322727,19.6437333 C12.3545909,14.112 17.5491591,10.1333333 23.7136364,10.1333333"
                            id="Fill-2"
                            fill="#EB4335"
                          />
                          <path
                            d="M23.7136364,37.8666667 C17.5491591,37.8666667 12.3545909,33.888 10.5322727,28.3562667 L2.62345455,34.3946667 C6.44540909,42.1557333 14.4268636,47.4666667 23.7136364,47.4666667 C29.4455,47.4666667 34.9177955,45.4314667 39.0249545,41.6181333 L31.5177727,35.8144 C29.3995682,37.1488 26.7323182,37.8666667 23.7136364,37.8666667"
                            id="Fill-3"
                            fill="#34A853"
                          />
                          <path
                            d="M46.1454545,24 C46.1454545,22.6133333 45.9318182,21.12 45.6113636,19.7333333 L23.7136364,19.7333333 L23.7136364,28.8 L36.3181818,28.8 C35.6879545,31.8912 33.9724545,34.2677333 31.5177727,35.8144 L39.0249545,41.6181333 C43.3393409,37.6138667 46.1454545,31.6490667 46.1454545,24"
                            id="Fill-4"
                            fill="#4285F4"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                  Login With Google
                </button>
                {/* <div class="separator-cus">
                  <div class="separator-cus-line"></div>
                  <h2>OR</h2>
                  <div class="separator-cus-line"></div>
                </div>
                {(errors.username && touched.username) ||
                (errors.password && touched.password) ? (
                  <div className="alert border-0 alert-danger alert-dismissible fade show  py-2">
                    <div className="d-flex align-items-center">
                      <div className="text-danger">
                        Username or Password is required!
                      </div>
                    </div>
                  </div>
                ) : null}

                <form onSubmit={handleSubmit} noValidate>
                  <div className="form-group">
                    <label className="form-control-label">USERNAME</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="username"
                      value={values.username || ""}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-control-label">PASSWORD</label>
                    <input
                      type="password"
                      className="form-control"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="password"
                      value={values.password || ""}
                    />
                  </div>

                  <div className="col-lg-12 loginbttm">
                    <button type="submit" className="btn btn-outline-primary">
                      LOGIN
                    </button>
                  </div>
                </form> */}
              </div>
            </div>
            <div className="col-lg-3 col-md-2"></div>
          </div>
        </div>
      </div>
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </div>
  );
}
